import React, { memo, useMemo } from 'react';
import { MenuItem } from 'primereact/menuitem';
import { PanelMenu } from 'primereact/panelmenu';
import './DonorMenu.css';
import { useNavigate } from 'react-router-dom';

const Donormenu = () => {
  const navigate = useNavigate();

  const items = useMemo<MenuItem[]>(
    () => {
      const createMenuItem = (
        label: string,
        icon: string,
        path?: string,
        children?: MenuItem[]
      ): MenuItem => ({
        label,
        icon,
        command: path ? () => navigate(path) : undefined,
        items: children,
        template: (item, options) => (
          <a {...options} data-testid={`menu-${label.toLowerCase().replace(/\s+/g, '-')}`}>
            <span className={item.icon}></span>
            <span className="ml-2">{item.label}</span>
          </a>
        )
      });

      return [
        createMenuItem('Dashboard', 'pi pi-fw pi-palette', '/ddashboard'),
        createMenuItem('Needs', 'pi pi-heart-fill', '/dneeds'),
        createMenuItem('Donations', 'pi pi-fw pi-dollar', '/donations'),
        createMenuItem('Documents', 'pi pi-file', '/documents'),
        createMenuItem('Urgent Needs', 'pi pi-heart', '/urgentneeds'),
        createMenuItem('Feedback', 'pi pi-envelope', '/feedback'),
        createMenuItem('Reports', 'nav-icon fas fa-copy', undefined, [
          createMenuItem('FundManager Reports', 'pi pi-user', '/fundreports'),
          createMenuItem('Organisation Reports', 'pi pi-sitemap', '/orgreports')
        ])
      ];
    },
    [navigate]
  );

  return (
    <aside className="main-sidebar">
      <div className="menu">
        <div className="font-bold border-round flex align-items-center justify-content-center">
          <PanelMenu model={items} />
        </div>
      </div>
    </aside>
  );
};

export default memo(Donormenu);
